<template>
    <div>
      <b-modal
        id="modal-extender-fecha"
        centered
        title="Extender Caducidad"
        hide-footer
      >
      <b-overlay
        id="overlay-background"
        :show="overlay_modal"
        rounded="sm"
      >
        <validation-observer ref="extenderValidation">
          <b-form @submit.prevent>
            <b-col>
              <b-form-group label="Fecha caducidad actual: ⌚">
                <b-form-input
                  id="fecha-caducidad"
                  v-model="fecha_caducidad_anterior"
                  disabled
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <label for="nueva-fecha-caducidad">Nueva Fecha caducidad: </label>
                <flat-pickr
                  v-model="nueva_fecha_caducidad"
                  :config="configdateTimePicker"
                  class="form-control"
                  placeholder="Seleccionar fecha caducidad..."
                />
            </b-form-group>
            </b-col>

            <b-col md="12" class="text-right">
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="btn-guardar mb-1"
                    @click="validationForm"
                    size="sm"
                >
                    <feather-icon
                    icon="ClockIcon"
                    size="16"
                    class="align-text-top"
                    />
                    <span>&nbsp;Extender</span>
                </b-button>
            </b-col>
          </b-form>
        </validation-observer>
        </b-overlay>
      </b-modal>
      <b-card-code class="mt-2 principal">
        <b-button
          id="btn-excel"
          ref="btnexcel"
          variant="primary"
          size="sm"
          style="
            margin-right: 1%;
            background: #37ef00 !important;
            border-color: #37ef00 !important;
          "
          @click="cargarDatosBoletos((excel_btn = '1'))"
        >
          <font-awesome-icon icon="fa-solid fa-file-excel" />
        </b-button>
        <b-button
          id="btn-pdf"
          variant="danger"
          size="sm"
          @click="cargarDatosBoletos((excel_btn = ''), (pdf_btn = '1'))"
        >
          <font-awesome-icon icon="fa-solid fa-file-pdf" />
        </b-button>
        <b-row class="mt-2">
          <b-col md="2">
            <b-form-group>
              <label>Número documento:</label>
              <b-form-input
                v-model="numero_documento"
                placeholder="Buscar por número de documento"
                type="text"
                class="d-inline-block"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label>Número de orden:</label>
              <b-form-input
                v-model="numero_orden"
                placeholder="Buscar por número de orden"
                type="text"
                class="d-inline-block"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label>Tarjeta:</label>
              <b-form-input
                v-model="tarjeta"
                placeholder="Buscar por tarjeta"
                type="text"
                class="d-inline-block"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label>Estado de marcación:</label>
              <v-select
                id="tipo_estado"
                v-model="estado_boletos"
                :options="tipo_estado"
                :reduce="(option) => option.value"
                label="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label>Tipo tarifa:</label>
              <v-select
                id="tipo_tarifa"
                v-model="tarifa"
                :options="tipo_tarifa"
                :reduce="(option) => option.value"
                label="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label>Tipo boleto:</label>
              <v-select
                id="tipo_boleto"
                v-model="boleto"
                :options="tipo_boleto"
                :reduce="(option) => option.value"
                label="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label>Tipo emisión:</label>
              <v-select
                id="tipo_emision"
                v-model="emision"
                :options="tipo_emision"
                :reduce="(option) => option.value"
                label="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label for="fecha-hasta">Fecha caducidad (desde): </label>
              <flat-pickr
                v-model="fecha_desde"
                :config="configdateTimePicker"
                class="form-control"
                placeholder="Seleccionar fecha caducidad desde..."
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label for="fecha-hasta">Fecha caducidad (hasta): </label>
              <flat-pickr
                v-model="fecha_hasta"
                :config="configdateTimePicker"
                class="form-control"
                placeholder="Seleccionar fecha caducidad hasta..."
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label for="fecha-hasta">Fecha emisión (desde): </label>
              <flat-pickr
                v-model="fecha_desde_emision"
                :config="configdateTimePicker"
                class="form-control"
                placeholder="Seleccionar fecha caducidad desde..."
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label for="fecha-hasta">Fecha emisión (hasta): </label>
              <flat-pickr
                v-model="fecha_hasta_emision"
                :config="configdateTimePicker"
                class="form-control"
                placeholder="Seleccionar fecha caducidad hasta..."
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4" class="pb-2">
            <b-button variant="primary" size="sm" @click="filtrar">
              <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Consultar
            </b-button>
          </b-col>
        </b-row>
      </b-card-code>
  
      <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
        <b-card-code class="principal">
          <b-col cols="12" class="pr-0 pl-0 mt-2">
            <b-table
              v-if="items.length > 0"
              bordered
              striped
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :items="items"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
              <!-- <template #head(secuencia)>
                <div class="text-center" v-b-tooltip.hover title="Secuencia">
                  <feather-icon icon="TrendingUpIcon" size="16" class="mr-1" />
                </div>
              </template> -->
              <template #cell(fecha_caducidad)="data">
                <a v-if="data.value && !data.item.tarjeta">{{ new Date(data.value).toLocaleString("pt-BR") }}</a>
                <span v-else>N/A</span>
              </template>
              <template #cell(fecha_creacion)="data">
                <div class="d-flex flex-column">
                  <span class="d-flex align-items-center">
                    <font-awesome-icon :icon="['fas', 'calendar-check']" class="text-success mr-1" v-b-tooltip.hover.bottom="'Fecha de emisión'"/>
                    <a>{{ new Date(data.value).toLocaleString("pt-BR") }}</a>
                  </span>
                  <span
                    v-if="data.item.fechamarcacionboleto"
                    class="d-flex align-items-center mt-1"
                  >
                    <font-awesome-icon :icon="['fas', 'clock']" class="text-warning mr-1" v-b-tooltip.hover.bottom="'Fecha de marcación'"/>
                    <a>{{ new Date(data.item.fechamarcacionboleto).toLocaleString("pt-BR") }}</a>
                  </span>
                </div>
              </template>

              <template v-slot:cell(numero_documento)="data">
                <span>{{
                  data.value
                }}</span>
                &nbsp;
                <b-badge variant="light-info" v-b-tooltip.hover title="Secuencia">
                {{ data.item.secuencia }}
                </b-badge>
              </template>
              <template #head(anulado)>
                <div class="text-center" v-b-tooltip.hover title="Anulado">
                  <font-awesome-icon :icon="['fas', 'ban']" />
                </div>
              </template>
              <template #cell(anulado)="data">
                <div v-if="data.value" class="text-center text-danger" v-b-tooltip.hover title="Boleto anulado">
                  <font-awesome-icon :icon="['fas', 'ban']" />
                </div>
              </template>
              <template #head(marcado)>
                <div class="text-center" v-b-tooltip.hover title="Marcación">
                  <font-awesome-icon :icon="['fas', 'bus']" />
                </div>
              </template>
              <template #cell(marcado)="data">
                  <font-awesome-icon v-if="data.value" class="text-center text-success" v-b-tooltip.hover.bottom="'Marcado'" :icon="['far', 'circle-check']" />
                  <font-awesome-icon v-else class="text-center text-second" v-b-tooltip.hover.bottom="'No marcado'" :icon="['far', 'circle-xmark']" />
              </template>
              <template #cell(origen)="data">
                <span
                  v-b-tooltip.hover
                  title="Digital"
                  v-if="data.item.detalleOrden && data.item.detalleOrden.orden && data.item.detalleOrden.orden.origen === 'ON' && data.item.tipo_version === 'V2'"
                >
                  <b-badge variant="light-info">
                    <feather-icon icon="SmartphoneIcon" size="14" /> Digital
                  </b-badge>
                </span>
                <span
                  v-b-tooltip.hover
                  title="Tarjeta"
                  v-else-if="data.item.detalleOrden && data.item.detalleOrden.orden && data.item.detalleOrden.orden.origen === 'TR' && data.item.tipo_version === 'V2'"
                >
                  <b-badge variant="light-success">
                    <feather-icon icon="CreditCardIcon" size="14" /> {{ data.item.tarjeta && data.item.tarjeta.codigo ? data.item.tarjeta.codigo : 'N/A' }}
                  </b-badge>
                </span>
                <span
                  v-b-tooltip.hover
                  title="POS"
                  v-else-if="data.item.detalleOrden && data.item.detalleOrden.orden && data.item.detalleOrden.orden.origen === 'POS' && data.item.tipo_version === 'V2'"
                >
                  <b-badge variant="light-warning">
                    <feather-icon icon="AirplayIcon" size="14" /> POS
                  </b-badge>
                </span>
                <span v-b-tooltip.hover title="Boleto físico" v-else>
                  <b-badge variant="light-info">
                    <feather-icon icon="FilmIcon" size="14" /> Físico
                  </b-badge>
                </span>
              </template>
              <template #cell(tipo_boleto)="data">
                <div v-if="data.value">
                  {{ procesarTipoBoleto(data.value) }}
                </div>
                <div v-else>N/A</div>
              </template>
              <template #cell(tipo_tarifa)="data">
                <div v-if="data.value">
                  {{ procesarTipoTarifa(data.value) }}
                </div>
                <div v-else>N/A</div>
              </template>
              <template #cell(detalleOrden)="data">
                <div v-if="data.value && data.value.orden && data.value.orden.codigo">
                  <a
                    :href="`/web_app/ordenes/?orden=${data.value.orden.codigo}`"
                    target="_blank"
                    class="text-primary font-weight-bold"
                  >
                    {{ data.value.orden.codigo }}
                  </a>
                </div>
                <div v-else>
                  N/A
                </div>
              </template>
              <template #cell(acciones)="data">
                <div v-if="data.item.detalleOrden">
                  <b-button-group v-if="(data.item.detalleOrden.orden.paymentezId) && data.item.marcado === false && data.item.anulado === false">
                    <!-- Botón para extender fecha de caducidad -->
                    <b-button
                        v-ripple.400="'rgba(255, 159, 67, 0.15)'"
                        variant="flat-success"
                        class="btn-icon"
                        v-b-tooltip.hover.bottom="'Extender Fecha de Caducidad'"
                        title="Extender Fecha de Caducidad"
                        @click="abrirModalExtenderFecha(data.item)"
                    >
                        <font-awesome-icon icon="calendar-plus" />
                    </b-button>
                </b-button-group>
                </div>
                
              </template>
            </b-table>
  
            <div v-else class="text-center">
              <p>No se encontraron registros</p>
            </div>
          </b-col>
  
          <b-col cols="12" class="mb-2">
            <b-pagination
              v-if="items.length > 0"
              v-model="currentPageModificado"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              :small="true"
              class="mb-0"
              align="center"
              prev-class="prev-item"
              next-class="next-item"
              @change="prueba"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-card-code>
      </b-overlay>
    </div>
  </template>
  
  <script>
  import {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
    BImg,
    BCardHeader,
    BCardGroup,
    BCardTitle,
    VBTooltip,
    BLink,
    BFormDatepicker,
    BOverlay,
    BForm,
    BButtonGroup,
  } from "bootstrap-vue";
  import Ripple from 'vue-ripple-directive'
  import vSelect from "vue-select";
  import BCardCode from "@core/components/b-card-code";
  import axios from "@/libs/axios";
  import actions from "@/assets/utils/utils";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import { Spanish } from "flatpickr/dist/l10n/es.js";
  import $ from "jquery";
  import Vue from "vue";
  import ToastificationContent from "@core/components/toastification/ToastificationContent";
  import es from "vee-validate/dist/locale/es.json";
  import VueSimpleSuggest from "vue-simple-suggest";
  import "vue-simple-suggest/dist/styles.css";
  import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { data } from "jquery";
  
  localize({
    es,
  });
  
  localize("es");
  
  export default {
    components: {
      BCardHeader,
      BCardGroup,
      BCardTitle,
      BCardCode,
      BTable,
      BAvatar,
      BBadge,
      BRow,
      BCol,
      BForm,
      BFormGroup,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormInput,
      BInputGroupAppend,
      BInputGroupPrepend,
      BButton,
      BButtonGroup,
      BImg,
      BLink,
      vSelect,
      BFormDatepicker,
      flatPickr,
      BOverlay,
      VueSimpleSuggest,
      ValidationProvider,
      ValidationObserver,
    },
    directives: {
      "b-tooltip": VBTooltip, Ripple
    },
  
    data() {
      return {
        overlay_modal: false,
        login_user: "",
        token_boleto: "",
  
        perPage: 15,
        pageOptions: [3, 5, 10],
        totalRows: 1,
        currentPage: 1,
        currentPageModificado: 1,
        sortBy: "",
        sortDesc: false,
        sortDirection: "asc",
        filter: null,
        filterOn: [],
        infoModal: {
          id: "info-modal",
          title: "",
          content: "",
        },
        fields: [
          {
            key: "detalleOrden",
            label: "# Orden",
            sortable: false,
            thClass: "text-center",
          },
          {
            key: "fecha_creacion",
            label: "Fechas",
            sortable: false,
            thClass: "text-center",
          },
          {
            key: "fecha_caducidad",
            label: "Fecha caducidad",
            thClass: "text-center",
          },
          {
            key: "numero_documento",
            label: "Información",
            sortable: false,
            thClass: "text-center",
            thStyle: { width: "20%" },
          },
          {
            key: "tipo_boleto",
            label: "Tipo Boleto",
            sortable: false,
            thClass: "text-center",
          },
          {
            key: "tipo_tarifa",
            label: "Tipo Tarifa",
            sortable: false,
            thClass: "text-center",
          },
          {
            key: "marcado",
            label: "Marcado",
            sortable: false,
            thClass: "text-center",
            thStyle: { width: "3%" },
          },
          {
            key: "anulado",
            label: "Anulado",
            sortable: false,
            thClass: "text-center",
            thStyle: { width: "3%" },
          },
          {
            key: "origen",
            label: "Emisión",
            sortable: false,
            thClass: "text-center",
          },
          {
            key: "acciones",
            label: "Acciones",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: { width: "7%" },
          },
        ],
        items: [],
        status: [
          {
            CUR: "En curso",
            FIN: "Finalizado",
            ANU: "Anulado",
            PEN: "Pendiente",
          },
          {
            FIN: "light-success",
            ANU: "light-secondary",
            CUR: "light-info",
            PEN: "light-warning",
          },
        ],
  
        codigo: "",
        chofer: "",
        bus: "",
        trayecto: "all",
        estado: "all",
  
        trayectos: [],
        estados: [],
  
        fecha_desde: "",
  
        fecha_hasta: "",
  
        fecha_finalizacion_desde: "",
  
        fecha_finalizacion_hasta: "",
  
        configdateTimePicker: {
          enableTime: false,
          dateFormat: "d/m/Y",
          locale: Spanish,
        },
        mostrarLoader: false,
  
        permisos: "",
  
        finderfield: {
          chosen: "",
          selected: null,
          modelo: { texto: "" },
          busqueda: { texto: "" },
          mode: "input",
          loading: false,
          cargando: false,
          data: null,
          dataCompleta: "",
        },
  
        finderfieldchofer: {
          chosen: "",
          selected: null,
          modelo: { texto: "" },
          busqueda: { texto: "" },
          mode: "input",
          loading: false,
          cargando: false,
          data: null,
          dataCompleta: "",
        },
  
        token_bus: "",
        token_chofer: "",
        tipo_boleto: [],
        tipo_tarifa: [],
        tarifa: "all",
        boleto: "all",
        numero_documento: "",
        numero_orden: "",
        tarjeta: "",
        fecha_caducidad_anterior: "",
        nueva_fecha_caducidad: "",
        emision: "all",
        tipo_emision: [{value: "DG", text: "Digital"}, {value: "FS", text: "Físico"}, {value: "TJ", text: "Tarjeta"}, {value: "all", text: "Todos"},],
        fecha_desde_emision: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString("pt-BR"),
        fecha_hasta_emision: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toLocaleDateString("pt-BR"),
        estado_boletos: "all",
        tipo_estado: [{value: "all", text: "Todos"}, {value: "M", text: "Marcado"}, {value: "NM", text: "No marcado"}],
      };
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter((f) => f.sortable)
          .map((f) => ({ text: f.label, value: f.key }));
      },
    },
    created() {
      this.comprobarPermisos();
      // this.comprobarPermisoEliminar();
      $("#btn-excel").remove();
      $("#btn-pdf").remove();
      $("#btn-print").remove();
      $("#eliminar-viajes").remove();
      $("#btn-abrir-caja").remove();
      this.setToken();
    },
    mounted() {
      actions.setearTitulo("");
      const params = new URLSearchParams(window.location.search);
      this.tarjeta = params.get("tarjeta") || "";
      this.cargarDatosBoletos();
      // this.totalRows = this.items.length
      this.cargarTrayectos();
      this.cargarEstados();
      $("#contenedor-botones")
        .append($("#btn-excel"))
        .append($("#btn-pdf"));
    },
    methods: {
      showToast(){
        this.$toast.success(
          {
            component: ToastificationContent,
            props: {
              title: "Boleto",
              icon: "InfoIcon",
              text: "Se ha cambiado la fecha de caducidad con éxito.",
            },
          },
          {
            position: "bottom-right",
          }
        );
      },
      validationForm() {
          this.$refs.extenderValidation.validate().then((success) => {
              if (success) {
                this.$swal({
                  title: 'Extender caducidad',
                  text: '¿Está seguro que desea cambiar la fecha de caducidad? Recuerde que está acción no tiene reversa.',
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonText: 'Cancelar',
                  confirmButtonText: 'Extender',
                  confirmButtonColor: '#089599',
                }).then(result => {
                  if (result.value) {
                    this.extenderFecha();
                  }
                })
              }
          }); 
      },
      extenderFecha(){
        this.overlay_modal = true
        axios.post("api", {
            query: `mutation extenderFecha($tokenBoleto: String!, $fechaCaducidad: String!){
                        extenderFecha(tokenBoleto:$tokenBoleto, fechaCaducidad:$fechaCaducidad)
                        {
                            status,
                            message,
                        }
                    }`,
            variables: {
                tokenBoleto: this.token_boleto,
                fechaCaducidad: this.nueva_fecha_caducidad
            },
            })
            .then((response) => {
            if (response.status === 200) {
                if (response.data.data.extenderFecha.status === "success") {
                  this.$bvModal.hide('modal-extender-fecha');
                  this.fecha_caducidad_anterior = ""
                  this.nueva_fecha_caducidad = ""
                  this.cargarDatosBoletos();
                  this.showToast();
                } else {
                this.$swal({
                    title: "Error",
                    text: response.data.data.extenderFecha.message,
                    icon: "error",
                    confirmButtonColor: "#089599",
                });
                }
            }
            this.overlay_modal = false
            });
      },
      abrirModalExtenderFecha(item){
        this.token_boleto = item.token
        this.fecha_caducidad_anterior = item.fecha_caducidad
        this.nueva_fecha_caducidad = ""
        this.$bvModal.show('modal-extender-fecha');
      },
      procesarTipoBoleto(texto) {
        for (const pasajero of this.tipo_boleto) {
          if (texto === pasajero.value) {
            return pasajero.text;
          }
        }
      },
      procesarTipoTarifa(texto) {
        for (const persona of this.tipo_tarifa) {
          if (texto === persona.value) {
            return persona.text;
          }
        }
      },
      onInputBusSuggest(newValue) {
        if (
          this.finderfield &&
          this.finderfield.data &&
          !this.finderfield.data.some((e) => e.value === newValue)
        ) {
          this.token_bus = "";
        }
      },
      onInputChoferSuggest(newValue) {
        if (
          this.finderfieldchofer &&
          this.finderfieldchofer.data &&
          !this.finderfieldchofer.data.some((e) => e.value === newValue)
        ) {
          this.token_chofer = "";
        }
      },
      ingresarMarcaciones(token) {
        this.$router.push({ name: "marcacion", params: { token } });
      },
      comprobarPermisos() {
        if (
          localStorage.getItem("permisos").indexOf("bol_boletos_consultar") === -1
        ) {
          this.$router.push({ name: "not-permitted" });
        } else {
          this.permisos = localStorage.getItem("permisos");
        }
      },
      // comprobarPermisoEliminar() {
      //   if (
      //     localStorage
      //       .getItem("permisos")
      //       .indexOf("eliminar_viajes_pendientes") !== -1 ||
      //     localStorage.getItem("permisos").indexOf("gest_bol_cadu_marcacion") !==
      //       -1
      //   ) {
      //     this.fields.splice(0, 0, {
      //       key: "acciones",
      //       label: "Acciones",
      //       thClass: "text-center",
      //       thStyle: { width: "10%" },
      //       tdClass: "text-center",
      //     });
      //   }
      // },
      filtrar() {
        this.cargarDatosBoletos();
      },
      eliminarViajes() {
        this.$swal({
          title: "Eliminación de viajes pendientes",
          text: "¿Está seguro de borrar los viajes pendientes vacíos?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, borrar!",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            axios
              .post("api", {
                query: `{
                          eliminarViajesPendientes{
                              status,
                              message,
                          }
                      }`,
              })
              .then((response) => {
                if (response.status === 200) {
                  if (
                    response.data.data.eliminarViajesPendientes.status ===
                    "success"
                  ) {
                    this.$swal({
                      icon: "success",
                      title: "Eliminar éxitoso!",
                      text: "Se ha borrado con éxito, los viajes pendientes.",
                      customClass: {
                        confirmButton: "btn btn-success",
                      },
                    });
                    this.cargarDatosBoletos("", "", 0, 15, 1);
                  }
                }
              });
          }
        });
      },
      cargarTrayectos() {
        axios
          .post("api", {
            query: `{
                      getTrayectos{
                          lista{
                              text,
                              value,
                          },
                          status,
                          message
                      }
                  }`,
          })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.data.getTrayectos.status === "success") {
                this.trayectos = response.data.data.getTrayectos.lista;
                this.trayectos.push({ text: "Todos", value: "all" });
              }
            }
          });
      },
      cargarEstados() {
        axios
          .post("api", {
            query: `{
                      getEstados{
                          lista{
                              text,
                              value,
                          },
                          status,
                          message
                      }
                  }`,
          })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.data.getEstados.status === "success") {
                this.estados = response.data.data.getEstados.lista;
                this.estados.push({ text: "Todos", value: "all" });
              }
            }
          });
      },
      prueba(value) {
        const pagina_actual = value;
        // this.currentPage = pagina_actual
        const limite_superior = value * this.perPage;
        const limite_inferior = (value - 1) * this.perPage;
        const desde = limite_inferior;
        const hasta = limite_superior;
  
        this.cargarDatosBoletos("", "", desde, hasta, pagina_actual);
      },
      cargarDatosBoletos(
        excel_btn = "",
        pdf_btn = "",
        desde = 0,
        hasta = 15,
        pagina_actual = 1
      ) {
        this.mostrarLoader = true;
        axios
          .post("api", {
            query: `query getAllBoletos($estado: String!, $numeroDocumento: String!, $numeroOrden: String!, $tarjeta: String!, $tipoEmision: String!, $tipoBoleto: String!, $tipoTarifa: String!, $fechaCaducidadDesde: String!, $fechaCaducidadHasta: String!, $fechaEmisionDesde: String!, $fechaEmisionHasta: String!, $excel: String!, $pdf: String!, $desde: Int!, $hasta: Int!){
                      getAllBoletos(estado: $estado, numeroDocumento: $numeroDocumento, numeroOrden: $numeroOrden,tarjeta: $tarjeta, tipoEmision: $tipoEmision, tipoBoleto: $tipoBoleto, tipoTarifa: $tipoTarifa, fechaCaducidadDesde: $fechaCaducidadDesde, fechaCaducidadHasta: $fechaCaducidadHasta, fechaEmisionDesde: $fechaEmisionDesde, fechaEmisionHasta: $fechaEmisionHasta, excel:$excel, pdf:$pdf, desde: $desde, hasta: $hasta){
                          boletos{
                              fecha_creacion: fechaCreacion,
                              fechamarcacionboleto,
                              secuencia,
                              tipo_boleto: tipoBoleto,
                              tipo_tarifa: tipoTarifa,
                              numero_documento: numeroDocumento,
                              tipo_version: tipoVersion,
                              fecha_caducidad: fechaCaducidad,
                              codigoQr,
                              boletoshort,
                              token,
                              marcado,
                              anulado,
                              detalleOrden{
                                orden{
                                  origen
                                  codigo
                                  tarjeta{
                                    codigo
                                  }
                                  paymentezId
                                }
                              }
                              tarjeta{
                                codigo
                              }
                          },
                          total,
                          dataarchivo,
                          status,
                          message,
                          listaTipoBoleto{
                              value,
                              text,
                          },
                          listaTipoTarifa{
                              value,
                              text,
                          },
                      }
                  }`,
            variables: {
              estado: this.estado_boletos,
              numeroOrden: this.numero_orden,
              numeroDocumento: this.numero_documento,
              tipoBoleto: this.boleto,
              tipoTarifa: this.tarifa,
              tipoEmision: this.emision,
              fechaCaducidadDesde: this.fecha_desde,
              fechaCaducidadHasta: this.fecha_hasta,
              fechaEmisionDesde: this.fecha_desde_emision,
              fechaEmisionHasta: this.fecha_hasta_emision,
              tarjeta: this.tarjeta,
              excel: excel_btn,
              pdf: pdf_btn,
              desde,
              hasta,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.data.getAllBoletos.status === "success") {
                if (response.data.data.getAllBoletos.boletos) {
                  this.items = response.data.data.getAllBoletos.boletos;
                  this.totalRows = response.data.data.getAllBoletos.total;
                  this.currentPage = 1;
                  this.currentPageModificado = pagina_actual;
                  this.tipo_boleto = response.data.data.getAllBoletos.listaTipoBoleto;
                  this.tipo_tarifa = response.data.data.getAllBoletos.listaTipoTarifa;                
                  this.tipo_boleto.push({ text: "Todos", value: "all" });
                  this.tipo_tarifa.push({ text: "Todos", value: "all" });

                } else {
                  const data = response.data.data.getAllBoletos.dataarchivo;
                  if (excel_btn === "1") {
                    actions.cargarArchivos(
                      data,
                      "Boletos.xlsx",
                      "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64"
                    );
                  } else {
                    actions.cargarArchivos(
                      data,
                      "Boletos.pdf",
                      "data:application/pdf;base64"
                    );
                  }
                }
              }
            }
            this.mostrarLoader = false;
          });
      },
      setToken() {
        const usuarioCookie = this.$cookie.get("usuario");
        if (usuarioCookie != null) {
          const user = JSON.parse(usuarioCookie);
          this.login_user = user.username;
          axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
        }
      },
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`;
        this.infoModal.content = JSON.stringify(item, null, 2);
        this.$root.$emit("bv::show::modal", this.infoModal.id, button);
      },
      resetInfoModal() {
        this.infoModal.title = "";
        this.infoModal.content = "";
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      newViaje() {
        this.$router.push({ name: "formviaje" });
      },
  
      preguntarEliminarViaje(codigo, token) {
        this.$swal({
          title: "Eliminación de viaje",
          text: `¿Está seguro que desea eliminar el viaje "${codigo}"?`,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Eliminar",
          confirmButtonColor: "#d9534f",
        }).then((result) => {
          if (result.value) {
            this.eliminarViaje(token);
          }
        });
      },
      eliminarViaje(token) {
        this.mostrarLoader = true;
        axios
          .post("api", {
            query: `mutation eliminarViaje($tokenViaje: String!){
                     eliminarViaje(tokenViaje:$tokenViaje)
                      {
                          message,
                          status,
                      }
                  }`,
            variables: {
              tokenViaje: token,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.data.eliminarViaje.status === "success") {
                this.cargarDatosBoletos();
                this.showToastViajeEliminado();
              } else {
                this.$swal({
                  title: "Error",
                  text: response.data.data.eliminarViaje.message,
                  icon: "error",
                  confirmButtonColor: "#089599",
                });
              }
            }
            this.mostrarLoader = false;
          });
      },
      showToastViajeEliminado() {
        this.$toast.success(
          {
            component: ToastificationContent,
            props: {
              title: "Viaje",
              icon: "InfoIcon",
              text: "Se ha eliminado con éxito el viaje",
            },
          },
          {
            position: "bottom-right",
          }
        );
      },
      async obtener_data(inputValue) {
        this.finderfield.cargando = true;
        let results;
        await axios
          .post("api", {
            query: `query autocompletar($texto: String!){
                      autocompletar(texto:$texto){
                          lista{
                              token,
                              label,
                              value
                          },
                          status,
                          message
                      }
                  }`,
            variables: {
              texto: inputValue,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.data.autocompletar.status === "success") {
                // const datos = response.data.data.autocompletar.lista
                results = response.data.data.autocompletar.lista;
                this.finderfield.data = results;
                this.finderfield.cargando = false;
              }
            }
          });
        const promise = new Promise((resolve, reject) => {
          resolve(results);
        });
  
        return promise;
      },
      async obtener_data_chofer(inputValue) {
        this.finderfieldchofer.cargando = true;
        let results;
        await axios
          .post("api", {
            query: `query autocompletarUsuario($texto: String!){
                      autocompletarUsuario(texto:$texto){
                          lista{
                              token,
                              label,
                              value
                          },
                          status,
                          message
                      }
                  }`,
            variables: {
              texto: inputValue,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.data.autocompletarUsuario.status === "success") {
                // const datos = response.data.data.autocompletar.lista
                results = response.data.data.autocompletarUsuario.lista;
                this.finderfieldchofer.data = results;
                this.finderfieldchofer.cargando = false;
              }
            }
          });
        const promise = new Promise((resolve, reject) => {
          resolve(results);
        });
  
        return promise;
      },
      boldenSuggestion(scope) {
        if (!scope) return scope;
        const { suggestion, query } = scope;
        const result = this.$refs.suggestComponent.displayProperty(suggestion);
        if (!query) return result;
        const texts = query.split(/[\s-_/\\|.]/gm).filter((t) => !!t) || [""];
        return result.replace(
          new RegExp(`(.*?)(${texts.join("|")})(.*?)`, "gi"),
          "$1<b>$2</b>$3"
        );
      },
      onSuggestSelect(suggest) {
        this.finderfield.selected = suggest;
        this.token_bus = this.finderfield.selected.token;
      },
      onSuggestSelectChofer(suggest) {
        this.finderfieldchofer.selected = suggest;
        this.token_chofer = this.finderfieldchofer.selected.token;
      },
    },
  };
  </script>
  <style>
  .principal .card-header {
    display: none !important;
  }
  .principal .card-body {
    padding-bottom: 0 !important;
  }
  .text-red {
    color: red;
  }
  [dir] .table th,
  [dir] .table td {
    padding-left: 1%;
    padding-right: 1%;
  }
  .vue-simple-suggest.designed .input-wrapper input {
    width: auto !important;
  }
  </style>
  